import * as tslib_1 from "tslib";
import common from '../../../../../common';
import { SheetDisplayMode } from "../../../../../form/schema";
import RelevanceFormModal from "../../../../../form/src/common/components/relevance-form-modal2.vue";
import { FormSheetControl } from '../../../../../form/src/common/controls/form-sheet-control';
import { RelevanceFormControl } from "../../../../../form/src/common/controls/relevance-form-control";
import ControlBack from '../../../../../form/src/common/directives/control-back';
import { ReverseQueryService } from "../../../../../form/src/common/services";
import BaseControlAdapter from "../../../../../form/src/renderer/components/mobile/base-control-adapter.vue";
import numberFilter from "../../../../../form/utils/number-filter";
import { H3CheckboxItem, H3Dialog, H3Field, H3Modal } from "h3-mobile-vue";
import { Component, Inject, Watch } from "vue-property-decorator";
let FormSheet = class FormSheet extends FormSheetControl {
    constructor() {
        super(...arguments);
        // 子表交互属性
        this.mode = SheetDisplayMode.Waterfall;
        this.currentIndex = 0;
        this.showModel = false;
        this.checkeds = [];
        this.shadowLeft = false;
        this.shadowRight = false;
        this.showRelevanceFormAdd = false;
        this.showModal = false;
        // get schemaCode() {
        //   return super.schemaCode;
        // }
        // get queryCode() {
        //   return super.queryCode;
        // }
        this.query = [];
    }
    // 子表计算属性
    get isHorizontal() {
        // return this.mode === "h";
        return this.isPage;
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get sheetTab() {
        return this.rows.length ? this.rows.length : 0;
    }
    get isWaterfall() {
        return this.mode === SheetDisplayMode.Waterfall;
    }
    get isPage() {
        return this.mode === SheetDisplayMode.Page;
    }
    get isTable() {
        return this.mode === SheetDisplayMode.Table;
    }
    get canDelete() {
        return this.checkeds.some(c => c);
    }
    // 是否可以编辑
    get editModal() {
        return !this.readonly && this.canEdit;
    }
    get isReadonly() {
        return this.readonly;
    }
    get checkedAll() {
        return this.checkeds.length > 0 && this.checkeds.every(c => c);
    }
    get indeterminate() {
        const checkeds = this.checkeds.filter(c => c);
        return checkeds.length > 0 && checkeds.length < this.checkeds.length;
    }
    checkAll(evt) {
        const checked = evt.target.checked;
        this.checkeds = this.checkeds.map(c => checked);
    }
    check(idx) {
        const checked = this.checkeds[idx];
        this.$set(this.checkeds, idx, !checked);
    }
    removeChecked() {
        this.checkeds
            .map((c, i) => (c ? i : -1))
            .filter(i => i > -1)
            .reverse()
            .forEach(i => this.splice(i));
    }
    customBtnclick(code) {
        const theBtn = this.sheetCustomActions.find(res => res.code === code);
        if (theBtn && theBtn.disabled) {
            return;
        }
        super.customBtnclick(code);
        this.showRelevanceFormAdd = false;
    }
    // 子表交互函数
    // changeMode() {
    //   // console.log("222");
    //   if (this.mode === "h") {
    //     this.mode = "v";
    //     return;
    //   }
    //   this.mode = "h";
    // }
    changeMode() {
        if (this.isWaterfall) {
            this.mode = SheetDisplayMode.Page;
        }
        else if (this.isPage) {
            this.mode = SheetDisplayMode.Table;
        }
        else if (this.isTable) {
            this.mode = SheetDisplayMode.Waterfall;
        }
    }
    changeTab(key) {
        if (this.showModel) {
            this.showModel = false;
            this.positionRow();
        }
        const idx = this.currentIndex;
        if (idx === key) {
            return;
        }
        this.currentIndex = key;
    }
    onWritableChange() {
        super.edit();
    }
    setControl() {
        this.mode =
            this.controlOpts.mobileDisplayMode || SheetDisplayMode.Waterfall;
        const ctrl = this.getCtrl();
        if (!ctrl) {
            return;
        }
        this.reset();
        super.listenPropertyChange();
        super.initStat();
        super.initRows(this.currentIndex, "mobile");
        this.checkeds = this.rows.map(() => false);
        super.listenRowChange();
        this.currentIndex = 0;
    }
    copy(idx) {
        super.copy(idx);
    }
    importRelevance() {
        this.show();
        this.query = this.getParams(true);
        this.columns = this.relavanceColumns();
        this.closeAdd();
    }
    addSheetRow() {
        if (this.importFormRelevanceForm || this.sheetCustomActions.length > 0) {
            this.showRelevanceFormAdd = true;
        }
        else {
            this.add();
        }
    }
    show() {
        this.showModal = true;
    }
    close() {
        this.showModal = false;
    }
    relevanceFormChange(val) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const formControls = this.getFormControls();
            // ;
            this.close();
            const dataitems = yield RelevanceFormControl.service.dataitemsOf(this.schemaCode);
            if (!val || val.length === 0)
                return;
            val.forEach(res => {
                const obj = {};
                this.control.columns.forEach(c => {
                    if (c.key === this.controlOpts.importFormRelevanceForm) {
                        // ;
                        let formData = res;
                        if (this.mappings) {
                            formData = ReverseQueryService.convertForMappings(res, dataitems, this.mappings, formControls);
                        }
                        obj[c.key] = formData;
                    }
                    else {
                        // obj[c.key] = null;
                    }
                });
                const backRow = this.addRow();
                backRow.value = obj;
                // this.addRow(obj);
            });
        });
    }
    closeAdd() {
        this.showRelevanceFormAdd = false;
    }
    add(idx, vals) {
        const row = typeof idx === "number" ? this.addRow(vals, idx) : this.addRow(vals);
        if (this.showRelevanceFormAdd) {
            this.closeAdd();
        }
    }
    splice(idx) {
        this.removeRow(idx);
    }
    rowInserted(index, row) {
        this.checkeds.splice(index, 0, false);
        this.changeTab(index);
        this.positionRow();
    }
    rowRemoved(index, row) {
        this.checkeds.splice(index, 1);
        this.changeTab(index === 0 ? 0 : index - 1);
        this.positionRow();
    }
    rowsInserted(index, rows) {
        const news = rows.map(() => false);
        this.checkeds.splice(index, 0, ...news);
        this.changeTab(index + rows.length - 1);
        // this.changeTab(index);
        this.positionRow();
    }
    rowsRemoved(indexs) {
        for (const index of indexs) {
            this.checkeds.splice(index, 1);
        }
        if (this.currentIndex > this.checkeds.length) {
            const index = this.checkeds.length === 0 ? 0 : this.checkeds.length - 1;
            this.changeTab(index);
        }
        this.positionRow();
    }
    search() {
        this.showModel = true;
    }
    showSearch() {
        this.emitScrollLock(true);
    }
    hideSearch() {
        this.emitScrollLock(false);
        this.showModel = false;
    }
    positionRow() {
        this.$nextTick(() => {
            if (this.mode === SheetDisplayMode.Waterfall) {
                const id = "#" + this.id + this.currentIndex;
                const el = this.$el.querySelector(id);
                if (el) {
                    this.emitScrollTop(el.offsetTop);
                }
            }
            else if (this.mode === SheetDisplayMode.Page) {
                const selectedTab = this.$refs.selectedTab;
                const tab = this.$el.querySelector(".h3-form-sheet-action-tab-selected");
                if (tab) {
                    selectedTab.scrollLeft = tab.offsetLeft;
                }
            }
        });
    }
    getColumnStyle(col) {
        return col.options.style;
    }
};
tslib_1.__decorate([
    Inject()
], FormSheet.prototype, "emitScrollTop", void 0);
tslib_1.__decorate([
    Inject()
], FormSheet.prototype, "emitScrollLock", void 0);
tslib_1.__decorate([
    Inject()
], FormSheet.prototype, "layoutTypeFn", void 0);
tslib_1.__decorate([
    Watch("isEdit")
], FormSheet.prototype, "onWritableChange", null);
FormSheet = tslib_1.__decorate([
    Component({
        name: "form-sheet",
        components: {
            BaseControlAdapter,
            H3Modal,
            H3Dialog,
            H3CheckboxItem,
            RelevanceFormModal,
            H3Field
        },
        filters: {
            number: numberFilter
        },
        directives: {
            ControlBack,
            TransferDom: common.directives.transferDom
        }
    })
], FormSheet);
export default FormSheet;
